var map = {
	"./0x0000000000000000000000000000000000000000.svg": 1025,
	"./0x1e991ea872061103560700683991a6cf88ba0028.svg": 1026,
	"./0x4c888e116d57a32f84865f3789dcb131fdc9fab6.svg": 1027,
	"./0xaa9e582e5751d703f85912903bacaddfed26484c.svg": 1028,
	"./0xbb10c3ba37b4da01a70d6f3f456c5323a11a76fb.svg": 1029,
	"./0xbbe47167666100ec33de9079c1ee7b150ccbd874.svg": 1030,
	"./0xc778417e063141139fce010982780140aa0cd5ab.svg": 1031,
	"./0xc7ad46e0b8a400bb3c915120d284aafba8fc4735.svg": 1032,
	"./0xcd1faff6e578fa5cac469d2418c95671ba1a62fe.svg": 1033,
	"./0xd3c325848d7c6e29b574cb0789998b2ff901f17e.svg": 1034,
	"./0xe1604b54cac27970aa67b4e38495f206b59cee42.svg": 1035,
	"./0xe2a59d5e33c6540e18aaa46bf98917ac3158db0d.svg": 1036,
	"./1art.svg": 1037,
	"./_default.svg": 31,
	"./_default_nft.svg": 92,
	"./avax.svg": 1038,
	"./bnb.svg": 1039,
	"./busd.svg": 1040,
	"./cirus.svg": 1041,
	"./dai.svg": 1042,
	"./default.svg": 1043,
	"./eth.svg": 1044,
	"./hai.svg": 1045,
	"./link.svg": 1046,
	"./matic.svg": 1047,
	"./niftsy.svg": 1048,
	"./plasma.svg": 1049,
	"./pos.svg": 1050,
	"./sca.svg": 1051,
	"./techniftsy.svg": 1052,
	"./ufi.svg": 1053,
	"./usdc.svg": 1054,
	"./usdt.svg": 1055,
	"./venvlp.svg": 1056,
	"./weth.svg": 1057,
	"./xtm.svg": 1058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;